import { useContext } from 'react';

import { AppContext } from 'Context/AppContext';
import { clearCachedState } from 'Utilities/helpers';
import {
	createSignOutMessage,
	windowCommunicationChannel,
} from 'Utilities/windowCommunicationChannel/windowCommunicationChannel.helpers';

type UseSignOutApi = {
	onSignOut: () => Promise<void>;
};

export const useSignOut = (): UseSignOutApi => {
	const appContext = useContext(AppContext);

	const onSignOut = async () => {
		clearCachedState();

		const userId = appContext?.state.user?.id;

		// Clear user state immediately so the UI reflects the logged-out state
		// before the redirect. Prevents stale nav/route guard state.
		appContext?.update({ user: null });

		try {
			await appContext?.api.signOut();
		} catch {
			// Swallow. The session may already be invalidated server-side.
			// The finally block ensures we still broadcast and redirect.
		} finally {
			windowCommunicationChannel.postMessage(createSignOutMessage(userId));
			window.location.replace('/');
		}
	};

	return { onSignOut };
};
